import './index.css';

function MoveUpIcon() {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.36148 7.75L7.63836 7.75C8.79605 7.75 9.51736 6.49418 8.93403 5.4942L6.29559 0.971146C5.71677 -0.0211123 4.28307 -0.0211138 3.70425 0.971144L1.06581 5.49419C0.482483 6.49418 1.20379 7.75 2.36148 7.75Z" fill="#131313"/>
    </svg>
  );
}

function MoveDownIcon() {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.63852 0.25L2.36164 0.25C1.20395 0.25 0.482641 1.50582 1.06597 2.5058L3.70441 7.02885C4.28323 8.02111 5.71693 8.02111 6.29575 7.02886L8.93419 2.50581C9.51752 1.50582 8.79621 0.25 7.63852 0.25Z" fill="#131313"/>
    </svg>
  );
}

function TrashIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.708 6.23975H3.75" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="#FC5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

function WidgetHeader(props) {
  const titleTypes = {
    LessonEmbedModule: "Embedded",
    LessonImageModule: "Image",
    LessonVideoModule: "Video",
    LessonTriggerModule: "Trigger",
    LessonCommentModule: "Text",
    LessonQuestionModule: "Question",
    LessonDownloadFileModule: "Download",
    LessonMultipleChoiceQuestionModule: "Multiple Choice",
    LessonFillInTheBlankModule: "Fill in the Blanks",
  }

  function onSwapWidgetPositionUp() {
    const { widgets, position } = props;
    const idx = position - 1;
    if (idx === 0) {
      return;
    }
    const arr = [...widgets];
    var a = arr[idx];
    arr[idx] = arr[idx - 1];
    arr[idx - 1] = a;

    var b = arr[idx].position;
    arr[idx].position = arr[idx - 1].position;
    arr[idx - 1].position = b;
    props.setWidgets(arr);
  }

  function onSwapWidgetPositionDown() {
    const { widgets, position } = props;
    const idx = position - 1;
    if (idx >= widgets.length - 1) {
      return;
    }
    const arr = [...widgets];
    var a = arr[idx];
    arr[idx] = arr[idx + 1];
    arr[idx + 1] = a;

    var b = arr[idx].position;
    arr[idx].position = arr[idx + 1].position;
    arr[idx + 1].position = b;
    props.setWidgets(arr);
  }
  
  return (
    <div className="WidgetHeader">
      <div style={{ display: "flex", alignItems: "center" }}>
        <div className="WidgetHeaderTag" />
        <div className="WidgetHeaderText">{titleTypes[props.lesson_module_name]}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <div className="WidgetHeaderDrag">
          <div className="WidgetHeaderDragUp" onClick={onSwapWidgetPositionUp}>
            <MoveUpIcon />
          </div>
          <div className="WidgetHeaderDragDown" onClick={onSwapWidgetPositionDown}>
            <MoveDownIcon />
          </div>
        </div>
        <div
          className="WidgetHeaderDelete"
          onClick={() => {
            props.onDelete(props);
          }}
          >
          <TrashIcon />
        </div>
      </div>
    </div>
  )
}

export { WidgetHeader };
